import React from 'react';

const InfoButton = ({ onClick, tooltip }) => {
    return (
        <button 
            onClick={onClick} 
            style={{
                backgroundColor: '#6c757d', // Changed to a gray color
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '16px',
                height: '16px',
                fontSize: '12px',
                fontFamily: 'Arial, sans-serif',
                fontWeight: 'bold',
                padding: 0,
                margin: '4px'
            }}
            aria-label="Info"
            title={tooltip}
        >
            i
        </button>
    );
};

export default InfoButton;
